/**
 * external dependencies
 */
var forge = require('node-forge');

/**
 * internal dependencies
 */
import { awsApiInstance } from '../api/aws-api';
import { IAwsSignIn } from '../models/login.interface';
import { setCognitoStore } from './cognito-store';

const encryptData = (data: string) => {
  const publicKeyString = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArj9H70KJCWkRSmgnxBsW
tmf2O4XrqnAi/obr4si6VX1RLuP9Sz9sQDchxWFS+ZL4V+055Cp37KPVAb3NaJUq
0+K5kzaJB89IaTh4x6tHRudCiGkEq7QY9u0xttxRd9pXaY/4iTOs7qAlLza3JII9
aag180/IFHt6JwSMc24q79ZaeVGckJjV7nIYBtMpenJry3xKYvbFZ0XCeqo9FXdF
WObNFHhomY4+FQG4Idn7ZL+aHL5FJatJj0bG0aAim7rxzaLiTPTo1tFkGkAgwoGi
b6LsB8RKp9j9LPCzI8KJmQb09UjqkM9NSOl3JYU2ethRfn21vAuoH6SNrY46wxv4
AQIDAQAB
-----END PUBLIC KEY-----`;

  const publicKey = forge.pki.publicKeyFromPem(publicKeyString);
  const encrypted = publicKey.encrypt(data, "RSA-OAEP", { 
    md: forge.md.sha1.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    }
  });

  const encryptedData = forge.util.encode64(encrypted);
 
  return encryptedData;
};

const CognitoLoginUser = async (userCreds: IAwsSignIn) => {
  try {
    const formattedData = `${userCreds.user}:${userCreds.pass}`;
    const token = encryptData(formattedData);

    const modalData = { 
      request: JSON.stringify(token)
    };

    const { data } = await awsApiInstance.post('/auth/login', modalData);

    setCognitoStore(data); 

    return data;
  } catch (err: any) {
    throw err;
  }
};

export default CognitoLoginUser;